export const LABEL = 'Students can go back to previous questions';
export const MESSAGE = 'Disabling this would restrict students in returning to previous questions once they have answered it.';
